import { render, staticRenderFns } from "./StudentTurnoverPrint.vue?vue&type=template&id=05e08c8e&scoped=true&"
import script from "./StudentTurnoverPrint.vue?vue&type=script&lang=js&"
export * from "./StudentTurnoverPrint.vue?vue&type=script&lang=js&"
import style0 from "./StudentTurnoverPrint.vue?vue&type=style&index=0&id=05e08c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e08c8e",
  null
  
)

export default component.exports